<div class="search {{ theme }}" [class.writting]="query">
  <label class="search-label">
    <input type="text" class="search-field" [placeholder]="placeholder" [(ngModel)]="query" (blur)="emit(query)" (keyup.enter)="emit(query)" (ngModelChange)="!query && emit(query)" #searchInput />
    <div class="search-button"><i class="fal fa-search"></i></div>
  </label>
</div>
